import { SxProps, Theme } from "@mui/material";

/**
 * Shared section-header style for the controls side-panel labels
 * (Display by, Segment by, Aggregate by, Filter by, Date period, ...).
 * Uppercase + weighted + muted so each header reads distinctly from the
 * value rendered beneath it.
 */
export const CONTROL_LABEL_SX: SxProps<Theme> = {
  fontSize: "10.5px",
  fontWeight: 600,
  letterSpacing: "0.6px",
  textTransform: "uppercase",
  color: "#8A9099",
  mb: "6px",
};
